import React from "react";
import {Button, Form, Input} from "antd";

type FieldType = {
    message?: string;

};

const ChatFooter = (props: any) => {
    return (
        <div className="chat__footer">
            <Form
                name="basic"
                form={props.form}
                onFinish={props.handleSendMessage}
                onFinishFailed={props.onFinishFailed}
                autoComplete="off">
                <div style={{display: "flex"}}>
                    <Input placeholder={"Type your message here!"}/>
                    <Button type="primary" htmlType="submit" style={{height: 40, borderRadius: "0px 10px 10px 0px"}}>
                        Send
                    </Button>
                </div>
            </Form>

        </div>
    );
};

export default ChatFooter;